import React, { useEffect, useState } from 'react';
import CommentWrapper from './CommentWrapper';
import { getPageSameType } from '../../utils/util';

interface IAllForComment {}

function AllForComment(props: IAllForComment) {
  const [showBottomComment, setShowBottomComment] = useState(false);
  const [classNames, setClassNames] = useState('');
  const setBottomComment = (flag: boolean | undefined) => {
    setShowBottomComment(prevState => (flag === undefined ? !prevState : flag));
  };
  // 监听打开评论的事件
  useEffect(() => {
    const bottomListener = function(e: any) {
      console.log(e);
      const { customType } = e;
      if (customType) {
        setClassNames(customType);
      }
      setBottomComment(true);
    };
    window.addEventListener('show-bottom-comment', bottomListener, false);
    return () => {
      window.removeEventListener('show-bottom-comment', bottomListener);
    };
  }, []);
  useEffect(() => {
    if (showBottomComment === false) {
      setClassNames('');
    }
  }, [showBottomComment]);

  const [canShow, setCanShow] = useState(true);
  useEffect(() => {
    let guide = [] as any[];
    getPageSameType(window.pageDetail.template, guide, ['guide']);
    if (guide && guide.length) {
      setCanShow(false);
    }
  }, []);

  return canShow ? (
    <CommentWrapper
      classNames={classNames}
      showBottomComment={showBottomComment}
      setBottomComment={setBottomComment}
      galleryId={window.gallery.id}
      type={1}
    />
  ) : (
    <div className="all-for-comment-can-show-false" />
  );
}

export default AllForComment;
